module.exports = __webpack_public_path__ + "71a3cb689137a9a9a63ba89b750347c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/category-chart.png
// module id = 1387
// module chunks = 0